import { render, staticRenderFns } from "./StagesForSidebar.vue?vue&type=template&id=1debe542&scoped=true"
import script from "./StagesForSidebar.vue?vue&type=script&lang=js"
export * from "./StagesForSidebar.vue?vue&type=script&lang=js"
import style0 from "./StagesForSidebar.vue?vue&type=style&index=0&id=1debe542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1debe542",
  null
  
)

export default component.exports